const KEY_TO_IDX: Record<string, number> = {
  C: 0, 'B#': 0,
  'C#': 1, Db: 1,
  D: 2,
  'D#': 3, Eb: 3,
  E: 4, Fb: 4,
  F: 5, 'E#': 5,
  'F#': 6, Gb: 6,
  G: 7,
  'G#': 8, Ab: 8,
  A: 9,
  'A#': 10, Bb: 10,
  B: 11, Cb: 11,
};

const SHARPS = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
const FLATS  = ['C', 'Db', 'D', 'Eb', 'E', 'F', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B'];

export function transposeKey(key: string, semitones: number): string {
  const idx = KEY_TO_IDX[key];
  if (idx === undefined) return key;
  const newIdx = ((idx + semitones) % 12 + 12) % 12;
  return semitones < 0 ? FLATS[newIdx] : SHARPS[newIdx];
}

export function semitonesFromTo(from: string, to: string): number {
  const a = KEY_TO_IDX[from] ?? 0;
  const b = KEY_TO_IDX[to] ?? 0;
  let diff = ((b - a) % 12 + 12) % 12;
  if (diff > 6) diff -= 12;
  return diff;
}

export function transposeChordToken(chord: string, semitones: number): string {
  if (semitones === 0) return chord;
  const rootMatch = chord.match(/^([A-G][b#]?)/);
  if (!rootMatch) return chord;
  const root = rootMatch[1];
  const rest = chord.slice(root.length);
  // Slash bass note is always at the end: e.g. G/B, Cmaj7/E
  const slashMatch = rest.match(/^(.*)(\/[A-G][b#]?)$/);
  if (slashMatch) {
    const quality = slashMatch[1];
    const bassNote = slashMatch[2].slice(1);
    return transposeKey(root, semitones) + quality + '/' + transposeKey(bassNote, semitones);
  }
  return transposeKey(root, semitones) + rest;
}
